import { unref } from 'vue';

import type { Ref } from 'vue';

export function useOriginScroll(isScrollAtTop: Ref<boolean>, isScrollAtBottom: Ref<boolean>) {
  let lock = false;
  let lockTimeout: any = null;

  function lockScroll() {
    clearTimeout(lockTimeout);

    lock = true;

    lockTimeout = setTimeout(() => {
      lock = false;
    }, 50);
  }

  return (deltaY: number, smoothOffset = false) => {
    const originScroll = (deltaY < 0 && unref(isScrollAtTop)) || (deltaY > 0 && unref(isScrollAtBottom));

    if (smoothOffset && originScroll) {
      clearTimeout(lockTimeout);

      lock = false;
    } else if (!originScroll || lock) {
      lockScroll();
    }

    return !lock && originScroll;
  };
}
